module.exports = "<div class=\"button-container\" [class.selected]=\"selected\" (click)=\"didClick()\">\n  <clr-icon *ngIf=\"shape\" [attr.shape]=\"shape\" [attr.size]=\"size\" [class.is-solid]=\"selected\"></clr-icon>\n  <span [style.font-size]=\"size - 4 + 'px'\"><ng-content></ng-content></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/toggle-button/toggle-button.component.html
// module id = ../../../../../src/app/common/toggle-button/toggle-button.component.html
// module chunks = main